import { Inertia } from '@inertiajs/inertia';
import { usePage } from '@inertiajs/inertia-react';
import React from 'react';

import DesktopMenuItem from './DesktopMenuItem';

function DesktopSidebar() {
  const { props, url } = usePage();
  const { auth } = props;

  return (
    <div className="hidden md:flex md:flex-shrink-0">
      <div className="flex flex-col w-64">
        <div className="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
          <div className="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <div className="flex items-center h-16 flex-shrink-0 px-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 5439.6 1882"
                className="text-indigo-600 h-20 py-3">
                <path
                  fill="currentColor"
                  d="M1760.6 1603.5c-9.5 136.9-22.1 186.4-101 186.4-22.1 0-69.4-8.8-104.1-8.8-22.1 0-28.4 14.6-28.4 29.1s6.3 26.2 28.4 26.2c116.7 0 274.5-5.8 520.6-5.8 280.8 0 508 5.8 627.9 5.8 18.9 0 28.4-11.7 28.4-26.2 0-11.7-9.5-26.2-28.4-26.2-25.2 0-60 5.8-75.7 5.8-78.9 0-94.6-49.5-101-186.4-6.3-203.9-15.8-498.1-15.8-789.4 0-203.9 3.1-410.7 15.8-582.6 6.3-93.2 12.6-183.5 91.5-183.5 31.5 0 63.1 8.7 85.2 8.7 18.9 0 28.4-17.5 28.4-29.1 0-14.6-9.5-26.2-28.4-26.2-151.4 0-334.4 11.6-508 11.6-208.2 0-290.3-11.6-416.5-11.6-85.2 0-97.8 23.3-107.3 75.7-53.6 335-104.1 501-173.5 745.7-28.4 99-50.5 160.2-101 160.2-47.3 0-75.7-55.4-116.7-218.5-44.2-168.9-97.8-512.6-113.6-672.8-9.5-72.8-31.6-90.3-91.5-90.3-183 0-271.3 11.6-533.2 11.6-148.3.2-350.2-11.5-514.3-11.5C9.5 1.4 0 13.1 0 27.7c0 11.6 9.5 29.1 28.4 29.1 22.1 0 53.6-8.7 85.2-8.7 104.1 0 119.9 102 119.9 215.5 0 763.2-69.4 1337-189.3 1485.6-28.4 37.9-41 43.7-41 64.1 0 14.6 9.5 23.3 25.3 23.3 56.8 0 154.6-5.8 280.8-5.8 186.1 0 287.1 5.8 350.2 5.8 22.1 0 31.5-17.5 31.5-26.2 0-20.4-9.5-29.1-72.6-84.5-224-195.2-337.6-681.6-337.6-1208.8 0-75.8 3.2-142.7 47.3-142.7 28.4 0 50.5 32 75.7 81.6 119.9 235.9 331.3 923.4 429.1 1255.4 31.5 107.8 41 122.3 249.3 122.3 217.7 0 252.4-14.6 274.5-122.3 88.4-436.9 208.3-996.2 293.4-1235.1 28.4-75.8 59.9-110.7 85.2-110.7 44.1 0 47.3 40.8 47.3 128.2 0 637.8-9.4 943.7-22 1109.7M3912.3 684.5c0-291.3 50.5-469 148.3-469 72.6 0 101 78.6 189.3 387.4 75.7 259.2 113.6 416.5 113.6 515.6 0 52.4-22.1 87.4-170.4 87.4-214.6 0-280.8-26.2-280.8-521.4m-154.7 1133.1c97.8 0 309.3 20.4 350.3 20.4 25.3 0 37.9-17.5 37.9-40.8 0-78.6-132.5-282.5-132.5-457.3 0-67 34.7-93.2 189.3-93.2 186.2 0 208.3 23.3 208.3 326.2 0 145.6-31.6 218.5-85.2 218.5-31.6 0-56.8-8.7-78.9-8.7-18.9 0-31.5 11.6-31.5 29.1 0 14.6 6.3 26.2 31.5 26.2 41 0 460.7-14.6 643.8-14.6 224 0 438.6 14.6 527 14.6 15.8 0 22.1-11.6 22.1-26.2 0-11.6-6.3-23.3-15.8-46.6-202-364.1-495.4-1293.3-495.4-1712.8 0-34.9-22.1-49.5-53.7-49.5-60 0-306.1 17.5-571.2 17.5C4092.1 20.4 3498 0 3390.8 0c-25.2 0-34.7 14.6-34.7 29.1 0 14.6 9.5 32.1 34.7 32.1 37.9 0 294.3-11.7 335.3-11.7 91.5 0 179.9 29.1 179.9 206.8 0 375.7-558.5 1147.7-558.5 1529.3 0 40.8 25.3 52.4 69.4 52.4 69.4 0 211.3-20.4 340.7-20.4M2892.1 1757.7h335.4v-49.4h-379.9V1882h44.5v-124.3zm58.6-167.7v-123.7l195.9 62.4-195.9 61.3zm-103.1 87.4l379.9-131.3v-35.8l-379.9-130.8v52.1l58.1 19.5v154.1l-58.1 20.1v52.1zm379.9-238.9v-52.1l-298.5-98.2 298.5-98.8v-52.1l-379.9 133v35.8l379.9 132.4zm-379.9-342.2h379.9v-51h-379.9v51zm0-237.4v49.4H3183v98.8h44.5V760.6H3183v98.2h-335.4zm121-360.9c-80.9 0-129.7 58.1-129.7 131.3 0 72.2 40.2 128.6 114.5 128.6 73.8 0 96.6-67.8 115.6-126.4 10.9-36.4 24.4-70.6 65.7-70.6 35.3 0 57 28.2 57 70 0 42.3-28.2 68.4-71.6 68.9v49.4c70-.6 116.1-50.5 116.1-119.4 0-68.4-41.2-118.3-101.5-118.3-77.1 0-96.1 56.4-117.8 124.8-9.8 33.1-22.8 72.2-68.9 72.2-39.6 0-64.6-31.5-64.6-75.4 0-51.5 33.1-85.8 85.2-85.8V498zm214.4-26h44.5V258.6h-379.9V472h44.5V308h122.1v164h44.5V308H3183v164zm0-257.2h44.5V1.4h-379.9v49.4h155.2v163.9h44.5V50.8H3183v164z"></path>
              </svg>
            </div>

            <nav className="mt-5 flex-1 px-2 bg-white space-y-1">
              <div className="ml-3 mb-4">
                <button
                  onClick={navigateToActivitiesNew}
                  className="px-2 py-1 flex group items-center text-white shadow font-medium text-sm rounded bg-green-500">
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                  Add Activity
                </button>
              </div>

              <DesktopMenuItem href="/dashboard">
                <svg className="mr-3 h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6"
                  />
                </svg>
                Dashboard
              </DesktopMenuItem>

              <DesktopMenuItem href="/activities">
                <svg className="mr-3 h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M8 7V3M16 7V3M7 11H17M5 21H19C20.1046 21 21 20.1046 21 19V7C21 5.89543 20.1046 5 19 5H5C3.89543 5 3 5.89543 3 7V19C3 20.1046 3.89543 21 5 21Z"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Activities
              </DesktopMenuItem>

              <DesktopMenuItem href="/projects">
                <svg
                  className="mr-3 h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
                Projects
              </DesktopMenuItem>

              <DesktopMenuItem href="/availabilities">
                <svg
                  className="mr-3 h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                Availabilities
              </DesktopMenuItem>

              <DesktopMenuItem href="/users">
                <svg className="mr-3 h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                  />
                </svg>
                Users
              </DesktopMenuItem>

              <DesktopMenuItem href="/locations">
                <svg className="mr-3 h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  <path
                    d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21M19 21L21 21M19 21H14M5 21L3 21M5 21H10M9 6.99998H10M9 11H10M14 6.99998H15M14 11H15M10 21V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V21M10 21H14"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Venues
              </DesktopMenuItem>

              <DesktopMenuItem href="/activity_types">
                <svg className="mr-3 h-6 w-6" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M21 10V11C21.5523 11 22 10.5523 22 10H21ZM21 14H22C22 13.4477 21.5523 13 21 13V14ZM3 14V13C2.44772 13 2 13.4477 2 14H3ZM3 10H2C2 10.5523 2.44772 11 3 11V10ZM5 4C3.34315 4 2 5.34315 2 7H4C4 6.44772 4.44772 6 5 6V4ZM19 4H5V6H19V4ZM22 7C22 5.34315 20.6569 4 19 4V6C19.5523 6 20 6.44772 20 7H22ZM22 10V7H20V10H22ZM20 12C20 11.4477 20.4477 11 21 11V9C19.3431 9 18 10.3431 18 12H20ZM21 13C20.4477 13 20 12.5523 20 12H18C18 13.6569 19.3431 15 21 15V13ZM22 17V14H20V17H22ZM19 20C20.6569 20 22 18.6569 22 17H20C20 17.5523 19.5523 18 19 18V20ZM5 20H19V18H5V20ZM2 17C2 18.6569 3.34315 20 5 20V18C4.44772 18 4 17.5523 4 17H2ZM2 14V17H4V14H2ZM4 12C4 12.5523 3.55228 13 3 13V15C4.65685 15 6 13.6569 6 12H4ZM3 11C3.55228 11 4 11.4477 4 12H6C6 10.3431 4.65685 9 3 9V11ZM2 7V10H4V7H2Z"
                  />
                  <path stroke="currentColor" d="M15 5V7" strokeWidth="2" strokeLinecap="round" />
                  <path
                    stroke="currentColor"
                    d="M15 11V13"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    stroke="currentColor"
                    d="M15 17V19"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                Activity Types
              </DesktopMenuItem>

              <DesktopMenuItem href="/data_control/overview">
                <svg
                  className="mr-3 h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
                  />
                </svg>
                Data Control
              </DesktopMenuItem>
            </nav>
            <div className="border-t p-2">
              <h4 className="font-medium text-gray-700">{auth.user.username}</h4>
              <button onClick={signOut} className="text-red-400">
                Uitloggen
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  function navigateToActivitiesNew() {
    Inertia.get('/activities/new', { referer: url });
  }

  function signOut() {
    Inertia.delete('/sessions/destroy');
  }
}

export default DesktopSidebar;
